export default __webpack_public_path__ + "static/media/Akash.02121000.png";